import { anatomy } from '@shared/tokens/anatomy.stylex';
import { colors } from '@shared/tokens/colors.stylex';
import { fonts } from '@shared/tokens/fonts.stylex';
import { palette } from '@shared/tokens/palette.stylex';
import { typography } from '@shared/tokens/typography.stylex';
import * as stylex from '@stylexjs/stylex';

export const styles = stylex.create({
  container: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    padding: '8px 0 8px 16px',
    alignItems: 'flex-start',
  },
  disabledRow: {
    opacity: 0.5,
  },
  containerTab: {
    display: 'flex',
    alignItems: 'flex-start',
    width: '100%',
    gap: anatomy['space-8'],
  },

  checkbox: {
    display: 'flex',
    padding: '4px 0',
    alignItems: 'flex-start',
    gap: anatomy['space-10'],
    alignSelf: 'stretch',
  },
  personCard: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '2px',
  },
  personDescription: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-start',
  },
  statusWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: anatomy['space-8'],
  },

  photo: {
    width: '36px',
    height: '36px',
    border: `1px solid ${colors.tertiaryBorder}`,
    borderRadius: anatomy.borderRadiusXxl,

    margin: '0 8px',
  },
  firstName: {
    fontFamily: fonts.din2014Regular,
    fontSize: typography['fontSizeCaption-1'],
    fontWeight: typography.fontWeighDemi,
    lineHeight: typography['lineHeightCaption-1'],
    overflow: 'hidden',
    color: colors.primaryText,
    textOverflow: 'ellipsis',
  },
  position: {
    fontFamily: fonts.din2014Regular,
    fontSize: typography['fontSizeCaption-3'],
    fontStyle: 'normal',
    fontWeight: typography.fontWeighRegular,
    lineHeight: typography['fontSizeCaption-2'],
    overflow: 'hidden',
    color: colors.secondaryText,
    textOverflow: 'ellipsis',
  },
  statuses: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: anatomy['space-8'],
  },
  invitationStatusesBlock: {
    display: 'flex',
    paddingTop: '2px',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-start',
    gap: anatomy['space-8'],
  },
  invitationStatusesItem: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: anatomy['space-20'],
  },
  invitationStatusesTitleBlock: {
    display: 'flex',
    width: '160px',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  invitationTitle: {
    fontFamily: fonts.din2014Demi,
    fontSize: typography['fontSizeCaption-2'],
    fontStyle: 'normal',
    lineHeight: typography['lineHeightCaption-2'],
    color: colors.primaryText,
  },
  invitationStatusBlock: {
    display: 'flex',
    padding: '2px 8px',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: anatomy.borderRadiusRound,
    background: palette['green-200'],
    cursor: 'pointer',
    color: palette['green-700'],
    border: 'none',
  },

  invitationStatusExpired: {
    display: 'flex',
    padding: '2px 8px',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: anatomy.borderRadiusRound,
    background: 'var(--grey-100)',
    color: 'var(--grey-700)',
    cursor: 'default',
  },

  invitationStatus: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    fontFamily: fonts.din2014Regular,
    fontSize: typography['fontSizeCaption-3'],
    fontStyle: 'normal',
    fontWeight: typography.fontWeighRegular,
    lineHeight: '12px',
  },
  invitationStatusIcon: {
    display: 'flex',
    cursor: 'pointer',
  },
  invitationStatusContainer: {
    position: 'relative',
  },
  confirmationAlert: {
    width: '372px',
    display: 'flex',
    padding: '8px 16px',
    borderRadius: anatomy.borderRadiusM,
    backgroundColor: colors.infoBackground,
    zIndex: 1000,
    gap: anatomy['space-8'],
  },
  confirmationAlertContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: anatomy['space-8'],
  },
  confirmationAlertText: {
    color: colors.primaryText,
    fontFamily: fonts.din2014Regular,
    fontSize: typography['fontSizeCaption-1'],
    fontStyle: 'normal',
    fontWeight: typography.fontWeighRegular,
    lineHeight: typography['lineHeightCaption-1'],
  },
  confirmationAlertButtons: {
    display: 'flex',
    gap: anatomy['space-8'],
    width: '100%',
  },
  statusBlock: {
    display: 'flex',
    gap: anatomy['space-4'],
    alignself: 'stretch',
    alignItems: 'flex-start',
  },
  statusTitle: {
    color: colors.tertiaryText,
    fontFamily: fonts.din2014Regular,
    fontSize: typography['fontSizeCaption-3'],
    fontStyle: 'normal',
    fontWeight: typography.fontWeighRegular,
    lineHeight: '12px',
  },
  sendStatus: {
    color: colors.primaryText,
    fontFamily: fonts.din2014Regular,
    fontSize: typography['fontSizeCaption-3'],
    fontStyle: 'normal',
    fontWeight: typography.fontWeighRegular,
    lineHeight: '12px',
  },
  borderIcon: {
    width: '100%',
    height: '1px',
    backgroundColor: colors.tertiaryBorder,
  },

  actions: {
    display: 'flex',
    alignItems: 'flex-start',
    alignSelf: 'stretch',
    gap: anatomy['space-8'],
    marginLeft: 'auto',
  },

  actionsIcon: {
    display: 'flex',
    padding: '4px',
    cursor: 'pointer',
    transition: 'color 0.2s ease-in-out',
    ':hover svg path': {
      fill: colors.accentIcon,
    },
  },

  actionsIconStroke: {
    display: 'flex',
    padding: '4px',
    cursor: 'pointer',
    transition: 'color 0.2s ease-in-out',

    ':hover svg path': {
      stroke: colors.accentIcon,
    },
  },

  infoTooltip: {
    width: '100%',
    height: '100%',
    backgroundColor: 'white',
    borderRadius: anatomy.borderRadiusS,
    background: colors.primaryInverseBackground,
  },
  infoRow: {
    display: 'flex',
    justifyContent: 'space-between',
    gap: anatomy['space-8'],
  },
  titleRow: {
    color: 'var(--foreground-tertiary, #8E9296)',
    fontFamily: fonts.din2014Regular,
    fontSize: typography['fontSizeCaption-3'],
    fontStyle: 'normal',
    fontWeight: typography.fontWeighRegular,
    lineHeight: '16px',
  },
  statusRow: {
    color: 'var(--foreground-primary-inverse, #FFF)',
    fontFamily: fonts.din2014Regular,
    fontSize: typography['fontSizeCaption-3'],
    fontStyle: 'normal',
    fontWeight: typography.fontWeighRegular,
    lineHeight: '16px',
  },
  checkboxDis: {
    width: '18px',
    height: '18px',
    cursor: 'not-allowed',
  },
  inactivePosition: {
    display: 'flex',
    padding: '2px 8px',
    justifyContent: 'center',
    alignItems: 'center',
    gap: anatomy['space-8'],
    borderRadius: anatomy.borderRadiusRound,
    background: palette['rose-100'],
  },
  inactivePositionText: {
    color: colors.errorText,
    textOverflow: 'ellipsis',
    fontFamily: fonts.din2014Regular,
    fontSize: typography['fontSizeCaption-3'],
    fontStyle: 'normal',
    fontWeight: typography.fontWeighRegular,
    lineHeight: '12px',
  },

  invitationStatusBlockWarning: {
    background: 'var(--red-200)',
    color: 'var(--red-700)',
  },

  invitationStatusBlockSent: {
    background: 'var(--lilac-200)',
    color: 'var(--lilac-700)',
  },
  customButton: {
    display: 'flex',
    padding: '4px 12px',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: anatomy.borderRadiusXs,
    border: `1px solid ${colors.primaryBorder}`,
    background: 'transparent',
    cursor: 'pointer',
    fontFamily: fonts.din2014Regular,
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: typography.fontWeighRegular,
    lineHeight: '16px',
    color: colors.primaryText,
    ':hover': {
      backgroundColor: colors.hoverBackground,
      borderColor: colors.hoverBorder,
    },
    ':active': {
      backgroundColor: colors.activeBackground,
    },
  },
});
